"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registry = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _AttachmentIcon = _interopRequireWildcard(require("../AttachmentIcon"));
var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));
var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));
var _Description = _interopRequireDefault(require("@material-ui/icons/Description"));
var _utils = require("../../utils");
var _excluded = ["icon", "fileName", "contentType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var registry = exports.registry = {
  image: {
    props: {
      className: 'text-orange'
    },
    Component: _Image["default"]
  },
  email: {
    props: {
      className: 'text-teal'
    },
    Component: _Email["default"]
  },
  "default": {
    props: {
      className: 'text-primary'
    },
    Component: _Description["default"]
  }
};
var _default = exports["default"] = function _default(_ref) {
  var icon = _ref.icon,
    fileName = _ref.fileName,
    contentType = _ref.contentType,
    res = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var iconType = (0, _utils.getAttachmentType)(contentType, fileName);
  if (_AttachmentIcon.iconMap[iconType]) {
    return /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
      colored: true,
      contentType: contentType,
      attachmentType: iconType,
      fileName: fileName
    });
  }
  var _get = (0, _get2["default"])(registry, icon, registry['default']),
    props = _get.props,
    Component = _get.Component;
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, res));
};
//# sourceMappingURL=index.js.map